<template>
  <v-list class="pt-0" dense>
    <template v-for="(advert, index) in Adverts">
      <v-divider v-if="index > 0" :key="index" inset></v-divider>

      <v-list-item
        @click="selectAdvert(advert.id)"
        two-line
        :key="advert.id"
        :class="{ selected: advert.id === SelectedAdvert.id }"
      >
        <v-list-item-avatar tile>
          <v-img :src="advert.image_url"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            v-text="advert.name"
            style="max-width:250px;overflow: hidden;text-overflow: ellipsis"
          ></v-list-item-title>
          <v-list-item-subtitle
            v-text="advert.url"
            style="max-width:250px;overflow: hidden;text-overflow: ellipsis"
          ></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AdvertList',
  computed: {
    ...mapGetters(['Adverts', 'SelectedAdvert', 'UILeftDrawer'])
  },
  methods: {
    ...mapActions(['getAdverts', 'selectAdvert', 'updateUILeftDrawerState']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  mounted() {
    this.getAdverts();
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .input-group--text-field input,
  .input-group__selections__comma {
    font-size: 13px;
  }
}

::v-deep textarea {
  font-size: 13px;
}

.theme--light {
  .input-group.input-group--solo-inverted.input-group--focused {
    background-color: #fff;
    ::v-deep input,
    ::v-deep .input-group__prepend-icon {
      color: rgba(0, 0, 0, 0.78);
    }
  }
  .subheader.text--accent-1 {
    color: #e91e63;
  }
  &.v-list {
    background: inherit;
  }
}

.btn-toggle--selected {
  box-shadow: none;

  .btn--active {
    color: #e91e63;

    > .btn__content:before {
      opacity: 0;
    }
  }
}

.theme--light .subheader.text--accent-1 {
  color: #e91e63;
}

::v-deep .tabs__item--active {
  color: #2196f3;
}

.hidden {
  display: none;
}

.selected {
  background: #b08faf;
  color: white;

  .list__tile__title {
    font-weight: 600;
  }

  .list__tile__sub-title {
    color: rgba(255, 255, 255, 0.87);
  }
}
</style>
